import { render, staticRenderFns } from "./ImageManagement.vue?vue&type=template&id=22f16ce8&scoped=true"
import script from "./ImageManagement.vue?vue&type=script&lang=js"
export * from "./ImageManagement.vue?vue&type=script&lang=js"
import style0 from "./ImageManagement.vue?vue&type=style&index=0&id=22f16ce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f16ce8",
  null
  
)

export default component.exports